import React, { useEffect, useState } from "react";
import ContentLayout from "../../../../partials/content/ContentLayout";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import DialogLayout from "../../../../partials/content/DialogLayout";
import Illustration from "../../../../partials/content/Illustration";
import { Badge } from "react-bootstrap";
import {
  getExchangeRates,
  deleteExchangeRate,
} from "../../../../services/finance/finance";
import NumberFormat from "react-number-format";
import { formatDate } from "../../../../utils/utils";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import ExchangeRateForm from "./exchangeRateForm";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import Swal from "sweetalert2";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
function ExchangeRate({ history }) {
  const { reload } = useGlobalData();
  const [exchangeRates, setExchangeRates] = useState([]);
  const [exchangeRate, setExchangeRate] = useState({});
  const [openExchangeRateForm, setOpenExchangeRateForm] = useState(false);
  const [auth, setAuth] = useState({ create: false });
  const exchangeRateDetailColumn = [
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];

  useEffect(() => {
    getExchangeRatesData();
  }, [reload]);
  const actionButtons = [
    {
      title: "",
      color: "label-brand",
      icon: "fas fa-backward",
      onClick: () => {
        history.push("/menu");
      },
    },
    {
      title: "New Exchange Rate",
      color: "primary",
      icon: "fas fa-plus-circle",
      onClick: () => {
        setExchangeRate({});
        setOpenExchangeRateForm(true);
      },
    },
  ];

  return (
    <React.Fragment>
      <PageSubHeader
        title="Exchange Rate List"
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/finance/exchange-rate",
            title: "Exchange Rates",
            active: true,
          },
        ]}
        actionButtons={actionButtons}
      />
      <ContentLayout>
        {exchangeRates.length ? (
          <CustomDataTable
            data={exchangeRates}
            dataDetailColumns={exchangeRateDetailColumn}
            onRefreshData={() => {
              getExchangeRatesData();
            }}
            columns={[
              {
                header: "Exchange Currency",
                field: "exCurrCode",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={`${rowData.exCurrCode} ➡ ${rowData.toCurrCode}`}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Valid From",
                field: "dateValidFrom",
                body: (rowData) => formatDate(rowData.dateValidFrom),
                sortable: true,
                filter: true,
              },
              {
                header: "Valid To",
                field: "dateValidTo",
                body: (rowData) => formatDate(rowData.dateValidTo),
                sortable: true,
                filter: true,
              },
              {
                header: "Exchange Rate Status",
                field: "exchangeRateStatusDesc",
                body: (rowData) => {
                  if (rowData.exchangeRateStatus === 1) {
                    return (
                      <Badge variant="success">
                        {rowData.exchangeRateStatusDesc}
                      </Badge>
                    );
                  } else if (rowData.exchangeRateStatus === 2) {
                    return (
                      <Badge variant="danger">
                        {rowData.exchangeRateStatusDesc}
                      </Badge>
                    );
                  } else {
                    return (
                      <Badge variant="dark">
                        {rowData.exchangeRateStatusDesc}
                      </Badge>
                    );
                  }
                },
                sortable: true,
                filter: true,
              },
              {
                header: "Exchange Rate To Base Currency",
                field: "exRateToBaseCurr",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.exRateToBaseCurr}
                    displayType={"text"}
                    thousandSeparator={true}
                    renderText={(value) => (
                      <div className="float-right">{value}</div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Exchange Rate To Foreign Currency",
                field: "exRateToForeignCurr",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.exRateToForeignCurr}
                    displayType={"text"}
                    thousandSeparator={true}
                    renderText={(value) => (
                      <div className="float-right">{value}</div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Actions",
                body: (rowData) => (
                  <React.Fragment>
                    {rowData.exchangeRateStatus === 1 ? (
                      <BootstrapTooltip title="Edit Exchange Rate">
                        <button
                          type="button"
                          onClick={(event) => {
                            setExchangeRate(rowData);
                            setOpenExchangeRateForm(true);
                          }}
                          className="btn btn-icon btn-label-primary btn-circle btn-md mx-1"
                        >
                          <i className="fas fa-edit"></i>
                        </button>
                      </BootstrapTooltip>
                    ) : null}
                    <BootstrapTooltip title="Delete Exchange Rate">
                      <button
                        type="button"
                        onClick={() => deleteExchangeRateData(rowData.ID)}
                        className="btn btn-icon btn-label-danger btn-circle btn-md mx-1"
                      >
                        <i className="fas fa-trash-alt"></i>
                      </button>
                    </BootstrapTooltip>
                  </React.Fragment>
                ),
                sortable: false,
              },
            ]}
          />
        ) : (
          <Illustration
            imageSource="INVIFO Payment.png"
            description="Hooray! You're ready to have your first Exchange Rate!"
            guidance='Hint: setup the exchange currency rates to base currency such as "IDR" to "USD", etc.'
            descriptionLeftIcon="fas fa-info-circle kt-font-success"
          ></Illustration>
        )}
      </ContentLayout>
      <DialogLayout
        open={openExchangeRateForm}
        title="Exchange Rate Form"
        onCloseDialog={() => {
          setOpenExchangeRateForm(false);
        }}
        maxWIdth="sm"
      >
        <ExchangeRateForm
          exchangeRate={exchangeRate}
          onConfirmSave={() => {
            getExchangeRatesData();
            setOpenExchangeRateForm(false);
          }}
          onCloseDialog={() => {
            setOpenExchangeRateForm(false);
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );

  async function deleteExchangeRateData(exchangeRateID) {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to delete this Exchange Rate ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, delete it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteExchangeRate(exchangeRateID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Deleted",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            getExchangeRatesData();
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  }

  async function getExchangeRatesData() {
    const response = await getExchangeRates();
    const { data, auth } = response.data;
    setExchangeRates(data.exchangeRates);
    setAuth(auth);
  }
}
export default ExchangeRate;
